import { render, staticRenderFns } from "./v80d3010.vue?vue&type=template&id=364a9964&"
import script from "./v80d3010.vue?vue&type=script&lang=js&"
export * from "./v80d3010.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports